import { Box, SxProps } from "@mui/material";
import React, { FC, memo } from "react";
import { calculateStarColor } from "../../util/scoringUtils";

interface IScoringRatingChipProps {
    rating: number;
    sx?: SxProps;
    label?: string;
}

const ScoringRatingChip: FC<IScoringRatingChipProps> = (props) => {
    const { rating, label, sx } = props;

    return (
        <Box
            component="span"
            sx={{
                display: "inline-block",
                borderRadius: "4px",
                backgroundColor: calculateStarColor(Math.floor(rating)),
                color: "white",
                padding: "2px 8px",
                ...sx,
            }}
        >
            {label}
            {rating.toFixed(2)}
        </Box>
    );
};

export default memo(ScoringRatingChip);
